<template>
  <div class="video-player">
    <video ref="videoPlayer" class="video-js" controls></video>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import EventBus from '@/event-bus';
import videojs from 'video.js';
import '@videojs/http-streaming';
let currentTime = 0;
let lastCurrentTime = 0;
let duration = 0;
let lastDuration = 0;

export default {
  name: "VideoPlayer",
  props: {
    options: {
      type: Object,
      default() {
        return {
          html5: { hls: { withCredentials: false } }
        };
      }
    },
    vdoSetTopicId: {
      type: String,
    }
  },
  data() {
    return {
      player: null
    }
  },
  methods: {
    generateVideoPlayer(){
      const _this = this;

      _this.player = videojs(_this.$refs.videoPlayer, _this.options, function onPlayerReady(event) {
        // console.log('Player Ready', this); // eslint-disable-line no-console
        // console.log('player Ref', _this.$refs.videoPlayer) // eslint-disable-line no-console
        _this.$refs.videoPlayer.controls = true;

        _this.player.currentTime(currentTime);
      });

      // EventBus.$on("VdoPlayer/instance", ({ command, vm, payload }) => {
      //   console.log("EventBus emitted VdoPlayer/instance:");

      //   if (payload && payload.currentUserId && payload.vdoSetTopicId) {
      //     currentTime = localStorage.getItem(payload.currentUserId + payload.vdoSetTopicId) || 0;
      //   }

      //   if (command === "change") {
      //     console.log("video changed", _this.player);
      //     if (_this.player) {
      //       this.play();
      //     }
      //   }
      // });

      //Get the current source type e.g. video/mp4 This can allow you rebuild the current source object so that you could load the same source and tech later
      //currentType()

      //Get/set dimension for player
      //dimension( dimension, [value] );

      //Destroys the video player and does any necessary cleanup
      //dispose()

      //Get the length in time of the video in seconds
      //duration(seconds)

      //Set or get the current MediaError
      //error(err)

      //Get the current muted state, or turn mute on or off
      //muted()

      // Returns the current state of network activity for the element
      // NETWORK_EMPTY (numeric value 0) The element has not yet been initialised. All attributes are in their initial states.
      // NETWORK_IDLE (numeric value 1) The element's resource selection algorithm is active and has selected a resource, but it is not actually using the network at this time.
      // NETWORK_LOADING (numeric value 2) The user agent is actively trying to download data.
      // NETWORK_NO_SOURCE (numeric value 3) The element's resource selection algorithm is active, but it has not yet found a resource to use.
      //networkState()

      // Calculates how much time is left.
      //remainingTime()
      // this.player.remainingTime();

      // Return a reference to the current tech
      //tech()
      // this.player.tech();

      // Converts track info to JSON
      //toJSON()

      this.player.on('timeupdate', function () {
        lastCurrentTime = _this.player.currentTime();
        EventBus.$emit('onVideoWatching', lastCurrentTime);
        EventBus.$emit('VideoPlayer/onVideoTimeUpdate', _this.player.currentTime());
        // EventBus.$emit('videoPlayingCount', { currentTime: _this.player.currentTime() });
        // lastDuration = _this.player.duration();
        // EventBus.$emit('VideoPlayer/onLoadedData', lastDuration);
      })

      this.player.on('invalid', function (event) {
        // const { target } = event;
        // console.log("Player's on invalid", event, this );
      });

      // Work when player initialized (before data is loaded)
      this.player.on('play', function (event) {
        // const { target } = event;
        // console.log("Player's on play", event, this );
      });

      this.player.on('error', function (event) {
        EventBus.$emit('VideoPlayer/onVideoError', event.target.player);

        // const { target } = event;
        // console.log("Player's on error", event, this );
      });

      // Work when video source was changed
      this.player.on('durationchange', function (event) {
        // const { target } = event;
        // console.log("Player's on duration change", event, this );
        // EventBus.$emit('VideoPlayer/onVideoInterrupt', {
        //   currentTime,
        //   duration
        // });
      });

      // Work when video source was loaded
      this.player.on('loadedmetadata', function (event) {
        // console.log(_this.vdoSetTopicId);
        if (_this.vdoSetTopicId) {
          const currentUserId = _this.$store.state.currentUser.id;
          currentTime = localStorage.getItem(currentUserId + "-" + _this.vdoSetTopicId) || 0;
          // console.log("currentTime", currentTime);
          _this.player.currentTime(currentTime);
        }
      });

      // Work when video source was loaded
      this.player.on('loadeddata', function (event) {
        // EventBus.$emit('VideoPlayer/onVideoInterrupt', _this.player.currentTime());
      });

      // Work when video is playing
      this.player.on('playing', function (event) {
        // EventBus.$emit('onVideoWatching', lastCurrentTime);
        EventBus.$emit('VideoPlayer/onVideoPlay', event.target.player);
        // const { target } = event;
        // console.log("Player's on playing", event, this );
      });

      // Work when video was paused (e.g. user intervention by clicking pause button)
      this.player.on('pause', function (event) {
        EventBus.$emit('VideoPlayer/onVideoInterrupt', _this.player.currentTime());
      });

      // Work when dragging seek controller
      this.player.on('seeking', function (event) {
        // const { target } = event;
        // console.log("Player's on seeking", event, this );
      });

      // Work when stop dragging seek controller
      this.player.on('seeked', function (event) {
        // const { target } = event;
        // console.log("Player's on seeked", event, this );
      });

      this.player.on('abort', function (event) {
        EventBus.$emit('VideoPlayer/onVideoInterrupt', _this.player.currentTime());
        // const { target } = event;
        // console.log("Player's on abort", event, this );
      });

      // Work when video source was met the end.
      this.player.on('ended', function (event) {
        EventBus.$emit('VideoPlayer/onVideoInterrupt', _this.player.currentTime());
      });
    }
  },
  mounted() {
    if(!this.player){
      this.generateVideoPlayer();
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>

<style lang="scss">
@import '/video.js/dist/video-js.css';

.video-player {
  width: 100% !important;
  height: auto !important;
  max-height: calc(100vh - 180px) !important;
  background: #22292f;
  overflow: hidden;
  position: relative;

  & .video-js {
    width: 100% !important;
    height: auto !important;
    padding-top: 0 !important;

    & video {
      width: 100% !important;
      height: auto !important;
      max-height: 100vh;
      @media only screen and (min-height: 600px) {
        max-height: calc(100vh - 200px);
      }
    }

    & .vjs-control-bar {
      display: none;
      z-index: 999999;
      position: absolute;
    }

    & .vjs-loading-spinner {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      // background: #0000005c;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      display: none;
    }

    & .vjs-big-play-button {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      width: 200px;
      height: 200px;
      background: #0000005c;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      border-radius: 50%;
      border-width: 5px;
      border-color: #ffffff5e;
      display: none;
    }

    & .vjs-control-bar {
      display: none;
      position: absolute;
      bottom: 0;
      height: 40px;
      background: red;
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      display: none;

      & > .vjs-control {
        margin: 10px;
      }

    }

    & .vjs-poster {
      display: none;
    }

    & .vjs-text-track-display {
      display: none;
    }

    & .vjs-error-display {
      display: none;
    }

    & .vjs-modal-dialog {
      display: none;
    }
  }
}
</style>
